// @module C3.ShoppingExtensions.PLP
define('C3.ShoppingExtensions.VisualSystemPage.ResourceMedia.View'
,	[
	'c3_shoppingextensions_visualsystempage_resource_media.tpl'
	
	//,	'C3.ShoppingExtensions.PLP.SS2Model'
	
	,	'Backbone'
	,   'C3.ShoppingExtensions.PLP.Resources.Model'
	,   'AjaxRequestsKiller'
	,   'C3.ShoppingExtensions.VisualSystemPage.ResourceMacro.View'
	,   'Backbone.CollectionView'
	,   'backbone_collection_view_row.tpl'
	,   'c3_shoppingextensions_visualsystempage_resource_cell_view.tpl'
	,   'Utils'
	,   'c3_shoppingextensions_visualsystempage_media_cell_view.tpl'
	,   'C3.ShoppingExtensions.VisualSystemPage.MediaMacro.View'
    ]
, function (
	c3_shoppingextensions_visualsystempage_resource_media_tpl
	
	//,	PLPSS2Model
	
	,	Backbone
	,   ResourceModel
	,   AjaxRequestsKiller
	,   ResourcesMacroView
	,   BackboneCollectionView
	,   backbone_collection_view_row_tpl
	,   c3_shoppingextensions_visualsystempage_resource_cell_view_tpl
	,   Utils
	,   c3_shoppingextensions_visualsystempage_media_cell_view_tpl
	,   MediaMacroView
)
{
    'use strict';

	// @class C3.ShoppingExtensions.PLP.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_visualsystempage_resource_media_tpl

	,	initialize: function (options) {

		   this.itemResources = options.resourcesArr;
		   this.itemMedia = options.MediaArr;
		   this.application = options.application;
		   this.configuration = options.configuration;

		   this.finalArrayToPass = [];
		   this.finalMediaArrayToPass = [];

		   var self = this;

		   var resourcesArrayData = this.itemResources;
		   var mediaArrayData = this.itemMedia;
				 
		   //console.log(resourcesArrayData);

			resourcesArrayData.forEach( function( resource ) {    
				var text = resource.text;  
				//console.log($.trim(text))          
				if(!_.findWhere(self.finalArrayToPass,{'text' : text}))
				    self.finalArrayToPass.push(resource)
	            });

			mediaArrayData.forEach( function( media ) {                
				if(!_.findWhere(self.finalMediaArrayToPass,{'video' : media.video}))
				    self.finalMediaArrayToPass.push(media)
	            });

			//console.log(this.finalMediaArrayToPass)
		}

	,	events: {
		}

	/*,  render: function(){
			this._render();
	    }	*/

	,	bindings: {
		}

	, 	childViews: {
			'Visual.System.Resources' : function(){
				var self = this;
				
				var viewsPerRowItems = 6;
            	if(Utils.isPhoneDevice())
            		viewsPerRowItems = 2;

            	//console.log(this.finalArrayToPass)

				var resourcesArrayData = this.finalArrayToPass;

				return new ResourcesMacroView({
					resources : resourcesArrayData,
					application: self.application
				})

				/*return new BackboneCollectionView({
	                collection: resourcesArrayData ? resourcesArrayData : [],
	                childView: ResourcesMacroView,
	                viewsPerRow: viewsPerRowItems,
	                cellTemplate: c3_shoppingextensions_visualsystempage_resource_cell_view_tpl,
	                rowTemplate: backbone_collection_view_row_tpl,
	                childViewOptions: {
	                    application: self.application
	                }
	            });*/
			},
			'Visual.System.Media' : function(){
				var self = this;
				
				var viewsPerRowItems = 6;
            	if(Utils.isPhoneDevice())
            		viewsPerRowItems = 2;

            	//console.log(this.finalArrayToPass)

				var mediaArrayData = this.finalMediaArrayToPass;

				return new BackboneCollectionView({
	                collection: mediaArrayData ? mediaArrayData : [],
	                childView: MediaMacroView,
	                viewsPerRow: viewsPerRowItems,
	                cellTemplate: c3_shoppingextensions_visualsystempage_media_cell_view_tpl,
	                rowTemplate: backbone_collection_view_row_tpl,
	                childViewOptions: {
	                    application: self.application
	                }
	            });
			}
		}

		//@method getContext @return C3.ShoppingExtensions.PLP.View.Context
	,	getContext: function getContext()
		{
			//console.log(this.finalArrayToPass)
			return {
				isPhoneDevice : Utils.isPhoneDevice(),
				hasResources : this.finalArrayToPass.length > 0,
				hasMedia : this.itemMedia.length > 0
			};
		}
	});
});
